import React from 'react';
import { Flex } from 'rebass';
const RowValue: React.FC<{
  text: React.ReactNode;
  children: React.ReactNode;
}> = ({ text, children }) => (
  <Flex alignItems="center" justifyContent="flex-end" sx={{ gap: 3 }}>
    {text}
    {children}
  </Flex>
);

export default RowValue;
